import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'momentUtc' })
export class MomentUtcPipe implements PipeTransform {
  transform(value: string, format: string = 'DD/MM/YY HH:mm:ss'): string {
    return moment.utc(value).format(format);
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_pipes/MomentUtcPipe.ts